import axios from "axios";

export const getBudgetTree = (
  id,
  clients,
  clientGroups,
  collaborators,
  role,
  year,
  searchWord
) => {
  const requestUrl = `/team/budget/tree`;

  let params = {
    organizationId: id,
    searchWord: searchWord,
    clients: clients.map(({ value }) => value),
    clientGroups: clientGroups.map(({ value }) => value),
    collaborators: collaborators.map(({ value }) => value),
    role,
    year
  };
  return axios.get(requestUrl, {
    params
  });
};

export const getClientGroupBudget = (searchWord, id) => {
  const requestUrl = `/team/client-groups`;
  let params = {
    organizationId: id,
    param: searchWord
  };
  return axios.get(requestUrl, {
    params
  });
};
export const getClientBudget = (searchWord, groups, id) => {
  const requestUrl = `/team/clients`;
  let filter = [];

  if (null !== searchWord && searchWord.length) {
    filter = [
      {
        property: "name",
        value: searchWord,
        operator: "like"
      }
    ];
  }

  let params = {
    organizationId: id,
    groups: groups,
    filter: JSON.stringify(filter),
    nolimit: true
  };
  return axios.get(requestUrl, {
    params
  });
};

export const getCollaboratorBudget = (id, year) => {
  const requestUrl = `/team/budget/collaborators`;

  let params = {
    organization: id,
    year: year
  };
  return axios.get(requestUrl, {
    params
  });
};

export const getQuickBudgetClient = (
  organizationId,
  clientId,
  year,
  suggestionFrom
) => {
  const requestUrl = `/team/quick-budget/client`;

  let params = {
    organizationId,
    clientId,
    year,
    suggestionFrom
  };
  return axios.get(requestUrl, {
    params
  });
};

export const getBudgetClient = (organizationId, clientId, year) => {
  const requestUrl = `/team/budget/client`;

  let params = {
    organizationId,
    client: clientId,
    year
  };
  return axios.get(requestUrl, {
    params
  });
};

export const saveQuickBudgetClient = ({
  organization,
  budget,
  clientId,
  year,
  status
}) => {
  const requestUrl = `/team/quick-budget/client/save`;
  let formData = new FormData();
  formData.append("organizationId", organization);
  formData.append("clientId", clientId);
  formData.append("managerId", budget.managerId);
  formData.append("supervisor", JSON.stringify(budget.supervisor));
  formData.append("year", year);
  formData.append(
    "hourlyBudget",
    budget.hourlyBudget ? budget.hourlyBudget : 0.0
  );
  formData.append(
    "economicBudget",
    budget.economicBudget ? budget.economicBudget : 0.0
  );
  formData.append("subs", JSON.stringify(budget.subs));

  formData.append("squadId", budget.squad.squadId);
  formData.append("clusterId", budget.cluster.clusterId);
  formData.append("businessUnitId", budget.businessUnit.businessUnitId);
  formData.append("status", status);

  return axios.post(requestUrl, formData);
};

export const getBudgetYears = organizationId => {
  const requestUrl = `/team/budget/years`;

  let params = { organizationId };
  return axios.get(requestUrl, {
    params
  });
};

export const updateBudgetClient = ({
  organization,
  year,
  budget,
  periodSetting,
  status
}) => {
  const requestUrl = `/team/budget/client/save`;
  let formData = new FormData();
  formData.append("year", year);
  formData.append("organization", organization);
  formData.append("budget", JSON.stringify(budget));
  formData.append("periodSetting", JSON.stringify(periodSetting));
  formData.append("status", JSON.stringify(status));

  return axios.post(requestUrl, formData);
};

export const cloneBudgetClient = budget => {
  const requestUrl = `/team/budget/client/clone`;
  let formData = new FormData();
  budget.budget && formData.append("budget", budget.budget);
  formData.append("organization", budget.organization);
  formData.append("client", budget.client);
  formData.append("year", budget.year);
  formData.append("base", budget.base);

  return axios.post(requestUrl, formData);
};

export const getBudgetStatesCount = (organizationId, period) => {
  const requestUrl = `/team/budget/count_budget_states`;

  let params = { organizationId, period };
  return axios.get(requestUrl, {
    params
  });
};

export const updateBudgetByRole = (organizationId, year) => {
  const requestUrl = `/team/budget/updateBudgetByRoles`;

  let formData = new FormData();
  formData.append("organizationId", organizationId);
  formData.append("year", year);
  return axios.post(requestUrl, formData);
};

export const getUpdatedBudget = (organizationId, year) => {
  const requestUrl = `/team/budget/getBudgetByRoles`;

  let params = { organizationId, year };
  return axios.get(requestUrl, {
    params
  });
};



// WEBPACK FOOTER //
// ./src/api/budget.js